import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import RowAmpTable from "./RowAmpTable";
import Globalview from "../../components/Globalview";
import { AmpColumn } from "../../components/headerContent";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table";
import { Link } from "react-router-dom";
import NumberCard from "../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function AmpTable({ displayArray }) {
  const { apiUrl } = useContext(AuthContext);
  const { t } = useTranslation();
  const location = useLocation();
  const [ampByPolicy, setAmpByPolicy] = useState([]);
  const [valueType, setValueType] = useState("all");
  const [resetValue, setResetValue] = useState(false);

  // Request to get all equipements
  const getAllAmp = async () => {
    const res = await axios(`${apiUrl}amp/index`, {
      method: "GET",
      withCredentials: true,
    });

    return res.data;
  };

  const amp = useQuery({
    queryKey: ["amp"],
    queryFn: getAllAmp,
  });

  const handleFilterByPolicy = () => {
    const ampFilterByPolicy =
      amp.isFetched &&
      amp.data.devices.filter((item) => {
        if (valueType === "pending_start" || valueType === "not_isolated") {
          return item.isolation.status === valueType;
        } else {
          return item.policy.name === valueType;
        }
      });
    setAmpByPolicy(ampFilterByPolicy);
  };

  useEffect(() => {
    handleFilterByPolicy();
  }, [valueType]);

  const isolateCounts = { name: "Isolation" };
  const policyCounts = { name: "Policy" };

  if (amp.isError) {
    return (
      <div className="ecp-container">
        <div className="ecp-container-content-error">
          <div className="error-container">
            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
            <div className="error-container-text">
              <h1 className="page-title">
                {t("Aucun équipement secure endpoint disponible")}
              </h1>
              <p className="page-link_home">
                <Link to="/"> {t("Revenir à l'accueil")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={location.pathname !== "/secure_endpoint/events" && "ecp-container"}>
      <div className={location.pathname !== "/secure_endpoint/events" && "ecp-container-content"}>
        {!amp.isLoading ? (
          <>
            <div className="ecp-container-content-header">
              <div className="ecp-container-content-header-title">
                <div className="page-title page-logo">
                  {!displayArray && (
                    <h1 className="page-title">{t('Ordinateurs Secure Endpoint')}</h1>
                  )}
                </div>
              </div>
            </div>
            <section className="page-section">
              <NumberCard
                title={t("Ordinateurs disponibles")}
                number={
                  ampByPolicy.length > 0
                    ? ampByPolicy.length
                    : amp.data.devices.length
                }
                logo={faCircleCheck}
                color={"#AEC353"}
                stylesIcons={"logo-certificats"}
              />
            </section>
            <section className="page-section">
              {amp.isFetched && (
                <>
                  <Globalview
                    data={amp.data.devices}
                    countObject={policyCounts}
                    objectKey="policy"
                    secondKey="name"
                    setValueType={setValueType}
                    click
                    resetValue={resetValue}
                    setResetValue={setResetValue}
                  />
                  <Globalview
                    data={amp.data.devices}
                    countObject={isolateCounts}
                    objectKey="isolation"
                    secondKey="status"
                    setValueType={setValueType}
                    click
                    resetValue={resetValue}
                    setResetValue={setResetValue}
                  />
                </>
              )}
              {valueType !== "all" && (
                <button
                  className="button button-new page-reset"
                  onClick={() => {
                    setValueType("all"),
                      setResetValue(true),
                      setNetworkChoose("all");
                  }}
                >
                  {" "}
                  Réinitialiser
                </button>
              )}
            </section>
            <div className='cato-content-table mt-1'>
              <Table
                tableData={valueType === "all" ? amp.data.devices : ampByPolicy}
                tableColumns={AmpColumn}
                rowComponent={RowAmpTable}
              />
            </div>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}
